import React from 'react';
import { Typography } from 'antd';
import { getUserBP, getUserName } from '../../utils/users';
import './GreetingsComponent.scss';

const GreetingsComponent = (): JSX.Element | null => {
  const render = (): JSX.Element | null => {
    const nameIze = (name?: string | null):string | null => {
      if (name === undefined || name == null) {
        return '';
      }

      const loweredText: string = name.toLowerCase();
      const words = loweredText.split(' ');

      for (let a = 0; a < words.length; a += 1) {
        let w = words[a];
        const firstLetter = w[0];

        if (w.length > 2) {
          w = firstLetter?.toUpperCase() + w.slice(1);
        } else {
          w = firstLetter + w.slice(1);
        }

        words[a] = w;
      }

      return words.join(' ');
    };

    const userBP: string | null = getUserBP();
    const userName: string | null = getUserName();
    const transformName = nameIze(userName);

    if (userBP && userName) {
      return (
        <Typography.Text
          className="GreetingsComponent GreetingsComponent__Title"
        >
          {
            `Olá, ${transformName} (${userBP})`
          }
        </Typography.Text>
      );
    }

    return null;
  };

  return render();
};

GreetingsComponent.propTypes = {};
GreetingsComponent.defaultProps = {};

export default GreetingsComponent;
